import React from 'react';

const OneWayFlightHeader = ({ from, to, departure, departureAirport, arrivalAirport }) => {
  const fromDisplay = departureAirport ? `${departureAirport.iata}` : from;
  const toDisplay = arrivalAirport ? `${arrivalAirport.iata}` : to;
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
    const day = date.getDate();
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${weekday} ${day} ${month} ${year}`;
  };

  return (
    <div className="mb-0">
      <div className="bg-[#ffd200] text-center py-4" style={{ minHeight: '70px' }}>
        <div className="font-bold text-base">
          {fromDisplay} → {toDisplay}
        </div>
        <div className="text-sm mt-1">
          {formatDate(departure)}
        </div>
      </div>
    </div>
  );
};

export default OneWayFlightHeader;
